import React from "react";
import './SignupModule.scss';
import { Button, FormFeedback, FormGroup, Input } from "reactstrap";
import { TextInput } from "../common/FormsInput";
import EmailBox from "../common/FormsInput/EmailBox";
import Head from "./Head";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

const SignUpOrganization = ({ children }) => {

    return (
        <>
            <div className="signup-wrapper signup-organization d-flex flex-fill overflow-auto">
                <div className="col-blc left-col d-flex">
                    <div className="inner d-flex align-items-end justify-content-center flex-fill position-relative">
                        <img className="img-fluid" src={require('../../assets/img/login/character.svg')} alt="Login-Character" />
                    </div>
                </div>
                <div className="col-blc right-col d-flex flex-column overflow-auto">
                    <div className="signup-header-block d-flex">
                        <div className="inner">
                            <Head heading="Welcome! Please signup to continue." className="signup-page" />
                            <div className="already-account">
                                Already a member? <Link to="/login" color="link">Sign In</Link>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-4 col-lg-6">
                            <FormGroup>
                                <label>Email</label>
                                <Input type="email" placeholder="Email" />
                            </FormGroup>
                        </div>
                        <div className="col-xl-4 col-lg-6">
                            <FormGroup>
                                <label>Password</label>
                                <Input type="password" placeholder="password" />
                            </FormGroup>
                        </div>
                        <div className="col-xl-4 col-lg-6">
                            <FormGroup>
                                <label>Confirm Password</label>
                                <Input type="password" placeholder="Confirm Password" />
                            </FormGroup>
                        </div>
                        <div className="col-xl-4 col-lg-6">
                            <FormGroup>
                                <label>Account Manager First Name</label>
                                <Input type="text" placeholder="Account Manager First Name" />
                            </FormGroup>
                        </div>
                        <div className="col-xl-4 col-lg-6">
                            <FormGroup>
                                <label>Account Manager Last Name</label>
                                <Input type="text" placeholder="Account Manager Last Name" />
                            </FormGroup>
                        </div>
                        <div className="col-xl-4 col-lg-6">
                            <FormGroup>
                                <label>Phone</label>
                                <Input type="phone" placeholder="Phone" />
                            </FormGroup>
                        </div>
                        <div className="col-xl-4 col-lg-6">
                            <FormGroup>
                                <label>Company Name</label>
                                <Input type="text" placeholder="Company Name" />
                            </FormGroup>
                        </div>
                        <div className="col-xl-4 col-lg-6">
                            <FormGroup>
                                <label>Company phone number</label>
                                <Input type="phone" placeholder="Company phone number" />
                            </FormGroup>
                        </div>
                        <div className="col-xl-4 col-lg-6">
                            <FormGroup>
                                <label>Company Website</label>
                                <Input type="text" placeholder="Company Website" />
                            </FormGroup>
                        </div>
                        <div className="col-xl-4 col-lg-6">
                            <FormGroup>
                                <label>Address</label>
                                <textarea className="form-control" placeholder="Address"></textarea>
                            </FormGroup>
                        </div>
                        <div className="col-xl-4 col-lg-6">
                            <FormGroup>
                                <label>Company Address</label>
                                <textarea className="form-control" placeholder="Company Address"></textarea>
                            </FormGroup>
                        </div>
                        <div className="col-xl-4 col-lg-6">
                            <FormGroup>
                                <label>Billing Information</label>
                                <textarea className="form-control" placeholder="Billing Information"></textarea>
                            </FormGroup>
                        </div>
                        <div className="signup-foot-blc">
                            <div className="term-blc">
                                <label className="d-flex align-items-center">
                                    <span className="checkbox-blc position-relative">
                                        <Input
                                            type="checkbox"
                                            className="position-absolute"
                                            name="acceptTerms"
                                        />
                                        <span className="icon-box d-inline-flex align-items-center justify-content-center">
                                            <span className="icon d-inline-flex">
                                                <FontAwesomeIcon icon={faCheck} />
                                            </span>
                                        </span>
                                    </span>
                                    <span>
                                        By clicking <strong>Create Account</strong> below, you agree to
                                        our terms of service and privacy statement.
                                    </span>
                                </label>
                            </div>
                            <div className="form-btns-rw text-end">
                                <Button color="primary">Create Account</Button>
                            </div>
                        </div>
                        {/*<div className="col-lg-4 col-md-6">
                            <TextInput
                                name="fname"
                                type="text"
                                placeholder="Account Manager First Name"
                                label="Account Manager First Name"
                            />
                        </div>
                         <div className="col-lg-4 col-md-6">
                            <TextInput
                                name="lname"
                                type="text"
                                placeholder="Account Manager Last Name"
                                label="Account Manager Last Name"
                                id={"accountManagerLastName"}
                            />
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <EmailBox
                                name="email"
                                id="email"
                                placeholder="Email"
                                label="Email"
                            />
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <TextInput
                                name="phone"
                                type="phone"
                                placeholder="Enter your last Name"
                                label="Last Name"
                                id={"lastname"}
                            />
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <TextInput
                                name="companyName"
                                type="text"
                                placeholder="Company Name"
                                label="Company Name"
                                id={"companyName"}
                            />
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <TextInput
                                name="companyPhoneNumber"
                                type="phone"
                                placeholder="Company phone number"
                                label="Company phone number"
                                id={"companyPhoneNumber"}
                            />
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <FormGroup className={`input-wrapper`}>
                                <label htmlFor="servicePlan">
                                    Service Plan
                                </label>
                                <select id="servicePlan" className="form-select">
                                    <option>
                                        Item One
                                    </option>
                                </select>
                            </FormGroup>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <FormGroup className={`input-wrapper`}>
                                <label htmlFor="billingPlan">
                                    Billing Plan
                                </label>
                                <select id="billingPlan" className="form-select">
                                    <option>
                                        Item One
                                    </option>
                                </select>
                            </FormGroup>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <FormGroup className={`input-wrapper`}>
                                <label htmlFor="status">
                                    Status
                                </label>
                                <select id="status" className="form-select">
                                    <option>
                                        Item One
                                    </option>
                                </select>
                            </FormGroup>
                        </div>
                        <div className="col-sm-12">
                            <div className="row">
                                <div className="col-lg-4 col-md-6">
                                    <TextInput
                                        name="address"
                                        type="textarea"
                                        placeholder="Address"
                                        label="Address"
                                        id={"address"}
                                    />
                                </div>
                                <div className="col-lg-4 col-md-6">
                                    <TextInput
                                        name="companyAddress"
                                        type="textarea"
                                        placeholder="Company Address"
                                        label="Company Address"
                                        id={"companyAddress"}
                                    />
                                </div>
                                <div className="col-lg-4 col-md-6">
                                    <TextInput
                                        name="billingInformation"
                                        type="textarea"
                                        placeholder="Billing Information"
                                        label="Billing Information"
                                        id={"billingInformation"}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <FormGroup>
                                <label htmlFor="phone">
                                    Address
                                </label>
                                <Input id="phone" type="textarea" placeholder="Address" />
                                <FormFeedback>This Field is require.</FormFeedback>
                            </FormGroup>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <FormGroup>
                                <label htmlFor="companyAddress">
                                    Company Address
                                </label>
                                <Input id="companyAddress" type="textarea" placeholder="Company Address" />
                                <FormFeedback>This Field is require.</FormFeedback>
                            </FormGroup>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <FormGroup>
                                <label htmlFor="billingInformation">
                                    Billing Information
                                </label>
                                <Input id="billingInformation" type="textarea" placeholder="Billing Information" />
                                <FormFeedback>This Field is require.</FormFeedback>
                            </FormGroup>
                        </div> */}
                    </div>
                </div>
            </div>
        </>
    )
};


export default SignUpOrganization;